import { render, staticRenderFns } from "./BullTableTwo.vue?vue&type=template&id=081b7615&scoped=true&"
import script from "./BullTableTwo.vue?vue&type=script&lang=js&"
export * from "./BullTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./BullTableTwo.vue?vue&type=style&index=0&id=081b7615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b7615",
  null
  
)

export default component.exports